"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleSampleFlaggedState = exports.strikeSampleChoice = exports.startSampleStationTimer = exports.handleSampleQuestionHighlights = exports.handleSampleChapterHighlights = exports.endSampleStation = exports.endSampleMarksheet = exports.checkSampleOsceMark = exports.MARK_OSCE_MARK_FRAGMENT = exports.changeSampleQuestion = exports.saveSampleTodoMark = exports.saveSampleMarksheets = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../fragments");
const marksheet_1 = require("../fragments/marksheet");
const query_1 = require("../query");
const marksheet_2 = require("../query/restricted/marksheet");
const restricted_1 = require("./restricted");
const saveSampleMarksheets = (client, marksheetInput, questionIndex) => {
    const { timeTaken, choiceId, mark, marksheetId } = marksheetInput;
    const prevData = client.readQuery({
        variables: { marksheetId },
        query: query_1.SAMPLE_MARKSHEET,
    });
    if (prevData) {
        const { sampleMarksheet } = prevData;
        const { marks = [], ...rest } = sampleMarksheet || {};
        client.writeQuery({
            query: query_1.SAMPLE_MARKSHEET,
            variables: { marksheetId },
            data: {
                ...prevData,
                sampleMarksheet: {
                    ...rest,
                    marks: [
                        ...marks.slice(0, questionIndex),
                        {
                            ...marks[questionIndex],
                            timeTaken,
                            isAnswered: true,
                            questionChoiceId: choiceId || null,
                            mark: mark || null,
                        },
                        ...marks.slice(questionIndex + 1),
                    ],
                },
            },
        });
    }
};
exports.saveSampleMarksheets = saveSampleMarksheets;
const saveSampleTodoMark = (client, todoInput, markId) => {
    const { timeTaken, score } = todoInput;
    client.writeFragment({
        id: `TodoMark:${markId}`,
        data: {
            score,
            timeTaken: timeTaken,
        },
        fragment: (0, client_1.gql) `
      fragment UpdatedTodoMark on TodoMark {
        score
        timeTaken
      }
    `,
    });
};
exports.saveSampleTodoMark = saveSampleTodoMark;
const changeSampleQuestion = (client, { newMarkId, timeTaken, markId, index, marksheetId, }) => {
    client.writeFragment({
        id: `MarksheetMark:${markId}`,
        data: { index, timeTaken },
        fragment: marksheet_1.MODIFY_CURRENT_MARKSHEET_MARK_FRAGMENT,
    });
    const prevData = client.readQuery({
        variables: { id: marksheetId },
        query: marksheet_2.MARKSHEET,
    });
    if (prevData) {
        client.writeQuery({
            query: marksheet_2.MARKSHEET,
            variables: { id: marksheetId },
            data: {
                ...prevData,
                restricted: {
                    ...prevData.restricted,
                    marksheet: {
                        ...prevData.restricted.marksheet,
                        currentMarkId: newMarkId,
                    },
                },
            },
        });
    }
};
exports.changeSampleQuestion = changeSampleQuestion;
exports.MARK_OSCE_MARK_FRAGMENT = (0, client_1.gql) `
  fragment CurrentOsceMarksheetMark on OsceMarksheetMark {
    mark
    selectedChoice
  }
`;
const checkSampleOsceMark = (client, isPaces, payload) => {
    const { osceMarksheetMarkId, mark } = payload || {};
    const data = {};
    if (isPaces) {
        data.selectedChoice = mark;
        data.mark = null;
    }
    else {
        data.mark = mark;
        data.selectedChoice = null;
    }
    client.writeFragment({
        id: `OsceMarksheetMark:${osceMarksheetMarkId}`,
        data,
        fragment: exports.MARK_OSCE_MARK_FRAGMENT,
    });
};
exports.checkSampleOsceMark = checkSampleOsceMark;
const endSampleMarksheet = (client, marksheetId) => {
    const prevData = client.readQuery({
        variables: { marksheetId: Number(marksheetId) },
        query: query_1.SAMPLE_MARKSHEET,
    });
    if (prevData) {
        const { sampleMarksheet } = prevData;
        const { startedAt = 0 } = sampleMarksheet || {};
        const endedAt = Math.round(Date.now() / 1000);
        client.writeQuery({
            query: query_1.SAMPLE_MARKSHEET,
            variables: { marksheetId: Number(marksheetId) },
            data: {
                ...prevData,
                sampleMarksheet: {
                    ...sampleMarksheet,
                    completed: true,
                    endedAt,
                    timeTaken: endedAt - Number(startedAt),
                },
            },
        });
    }
};
exports.endSampleMarksheet = endSampleMarksheet;
const endSampleStation = (client, payload) => {
    const { osceMarksheetId, ...rest } = payload || {};
    if (osceMarksheetId) {
        const prevData = client.readQuery({
            variables: { osceMarksheetId: Number(osceMarksheetId) },
            query: query_1.SAMPLE_OSCE_MARKSHEET,
        });
        if (prevData) {
            client.writeQuery({
                query: query_1.SAMPLE_OSCE_MARKSHEET,
                variables: { osceMarksheetId: Number(osceMarksheetId) },
                data: {
                    ...prevData,
                    sampleOsceMarksheet: {
                        ...prevData.sampleOsceMarksheet,
                        ...rest,
                        completed: true,
                    },
                },
            });
        }
    }
};
exports.endSampleStation = endSampleStation;
const handleSampleChapterHighlights = (client, highlights, chapterId) => {
    try {
        client.cache.writeFragment({
            id: client.cache.identify({
                id: chapterId,
                __typename: 'Chapter',
            }),
            data: {
                highlights: highlights.map((highlight) => ({
                    __typename: 'HighlightNode',
                    tag: '',
                    color: '',
                    ...highlight,
                    part: highlight.part || '',
                })),
            },
            fragment: fragments_1.CHAPTER_WITH_HIGHLIGHT_FIELDS,
        });
    }
    catch (error) {
        console.error(error);
    }
};
exports.handleSampleChapterHighlights = handleSampleChapterHighlights;
const handleSampleQuestionHighlights = (client, highlights, questionId, questionTypeId) => {
    try {
        client.cache.writeFragment({
            id: client.cache.identify({
                id: questionId,
                __typename: (0, restricted_1.getQuestionTypeName)(questionTypeId),
            }),
            data: {
                highlights: highlights.map((highlight) => ({
                    __typename: 'HighlightNode',
                    tag: '',
                    color: '',
                    ...highlight,
                    part: highlight.part || '',
                })),
            },
            fragment: fragments_1.QUESTION_WITH_HIGHLIGHT_FIELDS,
        });
    }
    catch (error) {
        console.error(error);
    }
};
exports.handleSampleQuestionHighlights = handleSampleQuestionHighlights;
const DEFAULT_STATION_TIME_IN_SECONDS = 930;
const startSampleStationTimer = (client, osceMarkhseetId) => {
    if (osceMarkhseetId) {
        const prevData = client.readQuery({
            variables: { osceMarksheetId: Number(osceMarkhseetId) },
            query: query_1.SAMPLE_OSCE_MARKSHEET,
        });
        const startedAt = Math.floor(Date.now() / 1000);
        if (prevData) {
            client.writeQuery({
                query: query_1.SAMPLE_OSCE_MARKSHEET,
                variables: { osceMarkhseetId: Number(osceMarkhseetId) },
                data: {
                    ...prevData,
                    sampleOsceMarksheet: {
                        ...prevData.sampleOsceMarksheet,
                        startedAt: startedAt,
                        endedAt: startedAt + DEFAULT_STATION_TIME_IN_SECONDS,
                        stage: 0,
                        state: 3,
                        timeRemaining: '15:30',
                        totalStationTime: '15:30',
                        stationTime: 10,
                        readingTime: 30,
                        feedbackTime: 5,
                    },
                },
            });
        }
    }
};
exports.startSampleStationTimer = startSampleStationTimer;
const strikeSampleChoice = (client, id, striked) => {
    client.cache.writeFragment({
        id: client.cache.identify({ id, __typename: 'MarksheetMark' }),
        data: { striked },
        fragment: marksheet_1.MODIFY_MARKSHEET_MARK_STRIKED_FRAGMENT,
    });
};
exports.strikeSampleChoice = strikeSampleChoice;
const toggleSampleFlaggedState = (client, markId, flagged) => {
    client.cache.writeFragment({
        id: client.cache.identify({
            id: Number(markId),
            __typename: 'MarksheetMark',
        }),
        data: {
            flagged: !flagged,
        },
        fragment: marksheet_1.MARK_FLAGGED_FIELD,
    });
};
exports.toggleSampleFlaggedState = toggleSampleFlaggedState;
